import gsap from 'gsap';
import Sniffer from 'sniffer';

export default class Pointer {
  constructor() {
    this.tX = 0;
    this.tY = 0;

    this.sX = 0;
    this.sY = 0;

    this.fX = 0;
    this.fY = 0;

    this.dot = document.querySelector('.pointer-dot');
    this.inner = document.querySelector('.pointer-inner');
    this.circle = document.querySelector('.pointer-circle');
  }

  init = () => {
    if (Sniffer.isDevice) return;

    this.events();

    window.addEventListener('mousemove', (e) => {
      this.tX = e.clientX;
      this.tY = e.clientY;
    });

    gsap.ticker.add(this.render);
  }

  events = () => {
    if (Sniffer.isDevice) return;

    this.cta = document.querySelectorAll('[data-cta]');
    this.indicator = document.querySelectorAll('[data-indicator]');

    [...this.cta].forEach((e) => {
      e.addEventListener('mouseenter', () => {
        gsap.to(this.inner, {
          scale: 1.5,
        });
      });
      e.addEventListener('mouseleave', () => {
        gsap.to(this.inner, {
          scale: 1,
        });
      });
    });

    [...this.indicator].forEach((e) => {
      e.addEventListener('mouseenter', this.enter);
      e.addEventListener('mouseleave', this.leave);
    });
  }

  enter = (e) => {
    gsap.to([this.dot, this.inner], {
      opacity: 0,
      duration: 0.2,
    });
    gsap.to(e.target.querySelector('.outer'), {
      scale: 1.3,
    });
  }

  leave = (e) => {
    gsap.to(this.dot, {
      opacity: 1,
      duration: 0.2,
    });
    gsap.to(this.inner, {
      opacity: 0.2,
      duration: 0.2,
    });
    gsap.to(e.target.querySelector('.outer'), {
      scale: 1,
    });
  }

  off = () => {
    if (Sniffer.isDevice) return;

    [...this.indicator].forEach((e) => {
      e.removeEventListener('mouseenter', this.enter);
      e.removeEventListener('mouseleave', this.leave);
    });
  }

  render = () => {
    this.sX += ((this.tX - this.sX) * 0.07);
    this.sY += ((this.tY - this.sY) * 0.07);

    this.fX += ((this.tX - this.fX) * 0.14);
    this.fY += ((this.tY - this.fY) * 0.14);

    this.dot.style.transform = `translate3d(${this.fX}px, ${this.fY}px, 0)`;
    this.circle.style.transform = `translate3d(${this.sX}px, ${this.sY}px, 0)`;
  }
}
